export const adjustImageSizes = (html: string): string => {
  // Regular expression to match image tags with width and height attributes
  const regex = /<img[^>]*\bwidth=["']?(\d+)["']?\b[^>]*\bheight=["']?(\d+)["']?[^>]*>/gi;

  // Replace matched image tags with adjusted width and height if width is greater than 397
  const adjustedHtml = html.replace(regex, (match, width) => {
    if (parseInt(width, 10) > 397) {
      return match
        .replace(/width=["']?\d+["']?/, 'width="100%"')
        .replace(/height=["']?\d+["']?/, 'height="auto"');
    }

    return match;
  });

  // Ensure all image tags have a width attribute set to 100% if not already present
  return adjustedHtml.replace(
    /<img(?![^>]*\bwidth\b)([^>]*)>/gi,
    '<img width="100%"$1>',
  );
};
